import React, { PureComponent } from 'react';
import { DatePicker as DatePickAnt } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';

export default class DatePicker extends PureComponent {
  render() {
    return (
      <DatePickAnt
        style={{ width: '100%' }}
        {...this.props}
        showTime={this.props.showTime}
        showToday={false}
        suffixIcon={<span className="icon-calendar-fill" />}
      />
    );
  }
}

DatePicker.propTypes = {
  format: PropTypes.string,
  showTime: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool
  ])
};

DatePicker.defaultProps = {
  format: 'HH:mm DD/MM/YYYY',
  showTime: {
    defaultValue: moment('00:00', 'HH:mm'),
    format: 'HH:mm'
  }
};
